export const paymentRecordsSelector = (state: RootState) => state.payments.paymentRecords;
export const paymentErrorSelector = (state: RootState) => state.payments.error;
export const paymentLoadingSelector = (state: RootState) => state.payments.loading;